import { render, staticRenderFns } from "./KpiDetail.vue?vue&type=template&id=2c64c442"
import script from "./KpiDetail.vue?vue&type=script&lang=js"
export * from "./KpiDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports